module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAKCAYAAAC9vt6cAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADfSURBVHgBjZFBDoIwEEWn5QJeQBI2EnYSook7OYI3gBt4A/EEHkFuomuNwZ2BDQQv4Nqk1E5TEAhUf9Kkmfz3ZzoF0OiWlkc8Og/RwcAhUK7Ys83w74AO/HUOhtB+IUmfuxZcqANYS7LyoA1AuOI8Uh1fb858RtkG71iqKtjKBkMBfZgR5q8cq1jOrDvemxDhaYeQMRjBdqdLls8NbpzEUyayMyGRa0/3pAMLiZHdPlzr+sjXlIiQenwRQgUcNA4O4RiMWjjWGThrfgJZKpeEmxaw55gx/JDnWLEMUUv+AO2HgMtxAwMWAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-up.png
// module id = 1191
// module chunks = 3